import {pagewebUrlMatcher} from '../../../applink/PagewebUrlMatcher.singleton';
import {twMerge} from '../../../common/twMerge';
import {DisplayAdFallback} from './DisplayAdFallback';
import {DisplayAdProps} from './DisplayAdProps.interface';
import {DisplayAdType} from './DisplayAdType.enum';

export function DisplayAd({
  noAdHandler,
  type = DisplayAdType.Normal,
  showFallback,
  displayAd,
  isWebView,
  className,
  ...props
}: DisplayAdProps) {
  return (
    <div
      className={twMerge(
        'flex justify-center overflow-hidden',
        type === DisplayAdType.Normal
          ? 'rounded-8pxr bg-static-etc-bg-da'
          : 'bg-transparent',
        className
      )}
      {...props}
    >
      <div
        className={twMerge(
          'flex w-full justify-center',
          type === DisplayAdType.Extended &&
            'overflow-hidden rounded-8pxr bg-static-etc-bg-da'
        )}
        style={{
          maxWidth:
            type === DisplayAdType.Extended
              ? BANNER_EXTENDED_AD_MAX_WIDTH
              : BANNER_AD_WIDTH,
          maxHeight:
            type === DisplayAdType.Extended
              ? BANNER_EXTENDED_AD_MAX_HEIGHT
              : BANNER_AD_HEIGHT,
          minWidth:
            type === DisplayAdType.Extended
              ? BANNER_EXTENDED_AD_MIN_WIDTH
              : BANNER_AD_WIDTH,
          minHeight:
            type === DisplayAdType.Extended
              ? BANNER_EXTENDED_AD_MIN_HEIGHT
              : BANNER_AD_HEIGHT,
        }}
      >
        {displayAd && !showFallback && (
          // https://ads-sdk-guide.dev.onkakao.net/web/banner-ad/3_install.html
          <ins
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className={twMerge('kakao_ad_area', 'hidden w-full')}
            data-ad-unit={displayAd.momentUid}
            data-ad-width={
              type === DisplayAdType.Extended
                ? BANNER_EXTENDED_AD_MIN_WIDTH
                : BANNER_AD_WIDTH
            }
            data-ad-height={
              type === DisplayAdType.Extended
                ? BANNER_EXTENDED_AD_MIN_HEIGHT
                : BANNER_AD_HEIGHT
            }
            data-ad-onfail={noAdHandler}
          />
        )}
        {(!displayAd || showFallback) && (
          <DisplayAdFallback
            type={type}
            onClickAppLink={() =>
              window.location.assign(
                isWebView
                  ? 'kakaopage://open/cashfriends'
                  : pagewebUrlMatcher.getAppLinkByScheme({
                      scheme: 'kakaopage://open/cashfriends',
                    })
              )
            }
            isWebView={isWebView}
          />
        )}
      </div>
    </div>
  );
}

const BANNER_AD_WIDTH = 320;
const BANNER_AD_HEIGHT = 68;
const BANNER_EXTENDED_AD_MIN_WIDTH = 320;
const BANNER_EXTENDED_AD_MIN_HEIGHT = 160;
const BANNER_EXTENDED_AD_MAX_WIDTH = 428;
const BANNER_EXTENDED_AD_MAX_HEIGHT = 214;
